// Reduction totale (réductions plafonnées + réductions non plafonnées)

const computeReductions = (rip, { cappedReductions, uncappedReductions }) => {
    const reductions = cappedReductions + uncappedReductions;

    return { reductions };
};

export default computeReductions;
